<template>
    <div class="fixed z-50 inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:items-start sm:justify-end sm:p-6">
        <!--
          Notification panel, show/hide based on notification state.

          Entering: "transform ease-out duration-300 transition"
            From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            To: "translate-y-0 opacity-100 sm:translate-x-0"
          Leaving: "transition ease-in duration-100"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <transition
            enter-active-class="transform ease-out duration-300 transition"
            enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition ease-in duration-100"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="open" class="absolute z-50 bottom-7 left-4 right-4 max-w-sm bg-white rounded-lg shadow-md pointer-events-auto overflow-hidden ring-1 ring-black ring-opacity-5 lg:left-auto lg:w-full">
                <div class="pl-2 pr-4 py-4 bg-blue-50 border-l-8 border-blue-400">
                    <div class="flex items-start">
                        <!--                    <div class="flex-shrink-0">-->
                        <!--                        &lt;!&ndash; Heroicon name: outline/inbox &ndash;&gt;-->
                        <!--                        <svg class="h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
                        <!--                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />-->
                        <!--                        </svg>-->
                        <!--                    </div>-->
                        <div class="flex-1 ml-3 pt-0.5 w-0">
                            <p class="text text-blue-900 font-semibold">
                                {{ notification.text }}
                            </p>
                            <p v-show="notification.subtext" class="line-clamp-2 mt-1 text-blue-800 text-sm">
                                {{ notification.subtext }}
                            </p>
                            <div class="flex mt-3 space-x-7">
                                <Link
                                    v-if="notification.primaryAction"
                                    :as="notification.primaryAction.method !== 'get' ? 'button' : 'a'"
                                    :href="notification.primaryAction.url"
                                    :method="notification.primaryAction.method"
                                    :preserve-scroll="true"
                                    class="hover:text-indigo-500 text-indigo-600 text-sm font-medium bg-white rounded-md focus:outline-none"
                                >
                                    {{ notification.primaryAction.text }}
                                </Link>
                                <button class="hover:text-gray-500 text-gray-700 text-xs font-medium bg-transparent rounded-md focus:outline-none uppercase" @click="close">Dismiss</button>
                            </div>
                        </div>
                        <!--<div class="ml-4 flex-shrink-0 flex">-->
                        <!--    <button class="bg-transparent rounded-md inline-flex text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="close">-->
                        <!--        <span class="sr-only">Close</span>-->
                        <!--        &lt;!&ndash; Heroicon name: solid/x &ndash;&gt;-->
                        <!--        <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">-->
                        <!--            <path clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" fill-rule="evenodd" />-->
                        <!--        </svg>-->
                        <!--    </button>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "NotificationWithActions",

    props: {
        notification: null,
        align: {
            default: "right",
        },
        width: {
            default: "96",
        },
        contentClasses: {
            default: () => ["bg-white"],
        },
    },

    data() {
        return {
            open: !!this.notification,
        }
    },

    created() {
        const closeOnEscape = (e) => {
            if (this.open && e.keyCode === 27) {
                this.open = false
            }
        }

        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", closeOnEscape)
        })

        document.addEventListener("keydown", closeOnEscape)
    },

    methods: {
        close() {
            this.$emit("update:notification", null)
        },
    },
}
</script>
